"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var tv4 = require('tv4');
var BioDetails = /*#__PURE__*/function () {
  function BioDetails(opt) {
    _classCallCheck(this, BioDetails);
    this.materialType = null;
    this.riskGroup = null;
    this.category = null;
    this.knownPathogens = null;
    this.naturalHost = null;
    this.naturalHost = null;
    this.exemptAmount = null;
    this.mouseLd50 = null;
    this.blp = null;
    if (opt) {
      this.fillObject(_objectSpread({}, opt));
    }
  }
  _createClass(BioDetails, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.materialType = opt.materialType || null;
      this.riskGroup = opt.riskGroup || null;
      this.category = opt.category || null;
      this.knownPathogens = opt.knownPathogens || null;
      this.naturalHost = opt.naturalHost || null;
      this.exemptAmount = opt.exemptAmount || null;
      this.mouseLd50 = opt.mouseLd50 || null;
      this.blp = opt.blp || null;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, BioDetails.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'library-item.bio.details.schema.json',
        title: 'Library Item Bio details Schema',
        type: 'object',
        additionalProperties: false,
        properties: {
          materialType: {
            type: ['string']
          },
          riskGroup: {
            type: ['string']
          },
          category: {
            type: ['string']
          },
          knownPathogens: {
            type: ['string', 'null']
          },
          naturalHost: {
            type: ['string', 'null']
          },
          exemptAmount: {
            type: ['string', 'null']
          },
          mouseLd50: {
            type: ['string', 'null']
          },
          blp: {
            type: ['string', 'null']
          }
        },
        required: Object.keys(new BioDetails())
      };
    }
  }]);
  return BioDetails;
}();
module.exports = BioDetails;